<template>
  <div id="app">
    <RequestProvider>
      <router-view :key="$route.fullPath" />
    </RequestProvider>
  </div>
</template>

<script>
import RequestProvider from './components/RequestProvider.vue';

export default {
  name: 'App',
  components: {
    RequestProvider
  },
  created() {},
  data() {
    return {};
  },
  provide() {
    return {};
  },
  methods: {
  }
};
</script>

<style>
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.page-content {
  flex: 1;
}
</style>